// ClientsGroupAttendanceRegisterMobile.js
import React, { useEffect, useState } from "react";
import {
  collection,
  addDoc,
  onSnapshot,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { List, ListItem, ListItemText, Typography } from "@mui/material";
import { db } from "../../firebase";
import GroupAttendanceModalMobile from "../Misc/GroupAttendanceModalMobile";

const NUM_SHIFTS = 11;

function ClientsGroupAttendanceRegisterMobile() {
  const [forms, setForms] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);

  // Pré-populer le form du jour s'il n'existe pas
  useEffect(() => {
    async function prepopulateForm() {
      const today = new Date();
      const year = today.getFullYear();
      const month = ("0" + (today.getMonth() + 1)).slice(-2);
      const day = ("0" + today.getDate()).slice(-2);
      const todayStr = `${year}-${month}-${day}`;

      const formsCollection = collection(db, "groupAttendanceForms");
      const q = query(formsCollection, where("date", "==", todayStr));
      const snapshot = await getDocs(q);
      if (snapshot.empty) {
        const defaultForm = {
          date: todayStr,
          attendances: Array.from({ length: NUM_SHIFTS }, () => ({})),
        };
        await addDoc(formsCollection, defaultForm);
      }
    }
    prepopulateForm();
  }, []);

  // Écoute en temps réel
  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, "groupAttendanceForms"),
      (snapshot) => {
        const formsData = [];
        snapshot.forEach((docSnap) => {
          formsData.push({ id: docSnap.id, ...docSnap.data() });
        });
        const uniqueForms = [];
        const seenDates = new Set();
        formsData.forEach((form) => {
          if (form.date && !seenDates.has(form.date)) {
            seenDates.add(form.date);
            uniqueForms.push(form);
          }
        });
        uniqueForms.sort((a, b) => {
          if (!a.date) return 1;
          if (!b.date) return -1;
          return a.date.localeCompare(b.date);
        });
        setForms(uniqueForms);
      }
    );
    return () => unsubscribe();
  }, []);

  const handleItemClick = (form) => {
    setSelectedForm(form);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedForm(null);
  };

  return (
    <div style={{ padding: "10px" }}>
      <Typography variant="subtitle1">Select a day</Typography>
      <List>
        {/* {forms.map((form) => ( */}
        {forms
          .sort((a, b) => new Date(b.date) - new Date(a.date)) // Tri des dates du plus récent au plus ancien
          .map((form) => (
            <div style={{ border: "1px solid lightgrey", borderRadius: "5px" }}>
              <ListItem
                button
                key={form.id}
                onClick={() => handleItemClick(form)}
              >
                <ListItemText primary={form.date} />
              </ListItem>
            </div>
          ))}
      </List>
      {selectedForm && (
        <GroupAttendanceModalMobile
          open={modalOpen}
          onClose={handleModalClose}
          formData={selectedForm}
        />
      )}
    </div>
  );
}

export default ClientsGroupAttendanceRegisterMobile;
